import _extends from "@babel/runtime/helpers/esm/extends";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { breakpointLg } from '@resultadosdigitais/tangram-design-tokens';
import NavbarAccount from './NavbarAccount';
import { useBoundary } from '../Boundary';
import Dropdown from '../Dropdown';
const DISPLAY_NAME = 'NavbarAccountInfo';
const StyledDropdownHeader = styled(Dropdown.Header).withConfig({
  displayName: "NavbarAccountInfo__StyledDropdownHeader",
  componentId: "sc-1bvnxbq-0"
})(["padding:0;@media (min-width:", "){display:none;}"], breakpointLg);
const Root = styled(NavbarAccount).withConfig({
  displayName: "NavbarAccountInfo__Root",
  componentId: "sc-1bvnxbq-1"
})([""]);
const NavbarAccountInfo = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    isInsideBoundary
  } = useBoundary();
  const isInsideDropdown = isInsideBoundary(Dropdown.displayName);
  if (isInsideDropdown) {
    return /*#__PURE__*/React.createElement(StyledDropdownHeader, null, /*#__PURE__*/React.createElement(Root, _extends({}, props, {
      ref: ref
    })));
  }
  return /*#__PURE__*/React.createElement(Root, _extends({}, props, {
    ref: ref
  }));
});
NavbarAccountInfo.displayName = DISPLAY_NAME;
NavbarAccountInfo.Style = Root;
export default NavbarAccountInfo;